import { GtmService } from '~/src/services/web-analytics.service';
import { getAnalyticsEventData } from '~/src/helpers/web-analytics-events-data.helper';
import { transliterate } from '~/src/helpers/transliterate.helper';
import {
    WebAnalyticsActionGroupEnum,
    WebAnalyticsEventActionEnum,
    WebAnalyticsEventCategoryEnum,
    WebAnalyticsEventEnum,
} from '~/src/models/enums/web-analytics.enum';

export const onSendProductClickAnalytics = (isChecked: boolean, productName?: string) => {
    GtmService.send(
        getAnalyticsEventData({
            eventAction: WebAnalyticsEventActionEnum.checkboxClick,
            eventLabel: 'vybor_produkta',
            eventContent: isChecked ? 'on' : 'off',
            event: WebAnalyticsEventEnum.vntEvent,
            eventCategory: WebAnalyticsEventCategoryEnum.createNewLeadRef,
            actionGroup: WebAnalyticsActionGroupEnum.interactions,
            productName: transliterate(productName),
        }),
    );
};
